import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../store';

export function ResetPasswordForm() {
  const { t } = useTranslation();
  const resetToken = useAuth(s => s.resetToken);
  const newPassword = useAuth(s => s.newPassword);
  const authLoading = useAuth(s => s.authLoading);
  const authError = useAuth(s => s.authError);
  const setResetToken = useAuth(s => s.setResetToken);
  const setNewPassword = useAuth(s => s.setNewPassword);
  const setAuthView = useAuth(s => s.setAuthView);
  const resetAuthForm = useAuth(s => s.resetAuthForm);
  const handleResetPassword = useAuth(s => s.handleResetPassword);

  const onSubmit = (e: React.FormEvent) => { e.preventDefault(); handleResetPassword(); };

  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <p className="text-sm font-medium text-gray-700">{t('storeSettings.resetPasswordTitle')}</p>
      <p className="text-xs text-gray-500">{t('storeSettings.resetPasswordHint')}</p>
      <input
        type="text"
        value={resetToken}
        onChange={e => setResetToken(e.target.value)}
        placeholder={t('storeSettings.resetToken')}
        required
        autoComplete="off"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <input
        type="password"
        value={newPassword}
        onChange={e => setNewPassword(e.target.value)}
        placeholder={t('storeSettings.newPassword')}
        required
        autoComplete="new-password"
        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      {authError && <p className="text-sm text-red-600">{authError}</p>}
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={authLoading || !resetToken.trim() || !newPassword}
          className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {authLoading ? t('storeSettings.resettingPassword') : t('storeSettings.resetPasswordAction')}
        </button>
        <button
          type="button"
          onClick={() => { setAuthView('login'); resetAuthForm(); }}
          className="rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-600 hover:bg-gray-50"
        >
          {t('common.cancel')}
        </button>
      </div>
    </form>
  );
}
